
import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'ModalFooter'
})
export default class ModalFooter extends Vue {

}
